/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { ColorObject } from './index';

// Color palette from https://www.colorxs.com/
export const vehicleColors: ReadonlyArray<ColorObject> = [
  // Base Values
  {
    id: '1',
    hex: '#000000',
    rgb: [0, 0, 0],
    name: 'Black',
    group: 'neutral',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '2',
    hex: '#993300',
    rgb: [153, 51, 0],
    name: 'Saddle Brown',
    group: 'neutral',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '3',
    hex: '#333300',
    rgb: [51, 51, 0],
    name: 'Black Brown',
    group: 'neutral',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '4',
    hex: '#003300',
    rgb: [0, 51, 0],
    name: 'Myrtle Green',
    group: 'green',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '5',
    hex: '#003366',
    rgb: [0, 51, 102],
    name: 'Dark Midnight Blue',
    group: 'blue',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '6',
    hex: '#000080',
    rgb: [0, 0, 128],
    name: 'Navy Blue',
    group: 'blue',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '7',
    hex: '#333399',
    rgb: [51, 51, 153],
    name: 'Cosmic Cobalt',
    group: 'blue',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '8',
    hex: '#333333',
    rgb: [51, 51, 51],
    name: 'Dark Charcoal',
    group: 'neutral',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '9',
    hex: '#800000',
    rgb: [128, 0, 0],
    name: 'Maroon Red',
    group: 'red',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '10',
    hex: '#FF6600',
    rgb: [255, 102, 0],
    name: 'Orange Crayola',
    group: 'orange',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '11',
    hex: '#808000',
    rgb: [128, 128, 0],
    name: 'Olive Green',
    group: 'green',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '12',
    hex: '#008000',
    rgb: [0, 128, 0],
    name: 'Office Green',
    group: 'green',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '13',
    hex: '#008080',
    rgb: [0, 128, 128],
    name: 'Teal',
    group: 'blue',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '14',
    hex: '#0000FF',
    rgb: [0, 0, 255],
    name: 'Blue',
    group: 'blue',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '15',
    hex: '#666699',
    rgb: [102, 102, 153],
    name: 'Rhythm',
    group: 'purple',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '16',
    hex: '#808080',
    rgb: [128, 128, 128],
    name: 'Neon Gray',
    group: 'neutral',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '17',
    hex: '#FF0000',
    rgb: [255, 0, 0],
    name: 'Red',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '18',
    hex: '#FF9900',
    rgb: [255, 153, 0],
    name: 'Orange Peel',
    group: 'orange',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '19',
    hex: '#99CC00',
    rgb: [153, 204, 0],
    name: 'Yellow Green',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '20',
    hex: '#339966',
    rgb: [51, 153, 102],
    name: 'Green NCS',
    group: 'green',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '21',
    hex: '#33CCCC',
    rgb: [51, 204, 204],
    name: 'Robin Egg Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '22',
    hex: '#3366FF',
    rgb: [51, 102, 255],
    name: 'Ultramarine Blue',
    group: 'blue',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '23',
    hex: '#800080',
    rgb: [128, 0, 128],
    name: 'Purple',
    group: 'purple',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '24',
    hex: '#969696',
    rgb: [150, 150, 150],
    name: 'Spanish Gray',
    group: 'neutral',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '25',
    hex: '#FF00FF',
    rgb: [255, 0, 255],
    name: 'Magenta ',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '26',
    hex: '#FFCC00',
    rgb: [255, 204, 0],
    name: 'Tangerine Yellow',
    group: 'yellow',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '27',
    hex: '#FFFF00',
    rgb: [255, 255, 0],
    name: 'Yellow',
    group: 'yellow',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '28',
    hex: '#00FF00',
    rgb: [0, 255, 0],
    name: 'Green',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '29',
    hex: '#00FFFF',
    rgb: [0, 255, 255],
    name: 'Aqua',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '30',
    hex: '#00CCFF',
    rgb: [0, 204, 255],
    name: 'Vivid Sky Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '31',
    hex: '#993366',
    rgb: [153, 51, 102],
    name: 'Amaranth Deep Purple',
    group: 'purple',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
  },
  {
    id: '32',
    hex: '#C0C0C0',
    rgb: [192, 192, 192],
    name: 'Silver',
    group: 'neutral',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '33',
    hex: '#FF99CC',
    rgb: [255, 153, 204],
    name: 'Pastel Magenta',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '34',
    hex: '#FFCC99',
    rgb: [255, 204, 153],
    name: 'Deep Peach',
    group: 'orange',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '35',
    hex: '#FFFF99',
    rgb: [255, 255, 153],
    name: 'Canary Yellow',
    group: 'yellow',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '36',
    hex: '#CCFFCC',
    rgb: [204, 255, 204],
    name: 'Tea Green',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '37',
    hex: '#C7F3F3',
    rgb: [199, 243, 243],
    name: 'Pale Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '38',
    hex: '#99CCFF',
    rgb: [153, 204, 255],
    name: 'Baby Blue Eyes',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '39',
    hex: '#CC99FF',
    rgb: [204, 153, 255],
    name: 'Baby Purple',
    group: 'purple',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  {
    id: '40',
    hex: '#FFFFFF',
    rgb: [255, 255, 255],
    name: 'White',
    group: 'neutral',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
  },
  // Cup Series
  {
    id: '41',
    hex: '#ff00ff',
    rgb: [255, 0, 255],
    name: 'Magenta',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '1',
  },
  {
    id: '42',
    hex: '#8fbd8f',
    rgb: [143, 189, 143],
    name: 'Dark Sea Green',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '2',
  },
  {
    id: '43',
    hex: '#ff6347',
    rgb: [255, 99, 71],
    name: 'Tomato',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '3',
  },
  {
    id: '44',
    hex: '#cc5c5c',
    rgb: [204, 92, 92],
    name: 'Indian Red',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '4',
  },
  {
    id: '45',
    hex: '#00bfff',
    rgb: [0, 191, 255],
    name: 'Deep Sky Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '5',
  },
  {
    id: '46',
    hex: '#6494ed',
    rgb: [100, 148, 237],
    name: 'Cornflower Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '6',
  },
  {
    id: '47',
    hex: '#db7093',
    rgb: [219, 112, 147],
    name: 'Pale Violet Red',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '7',
  },
  {
    id: '48',
    hex: '#999933',
    rgb: [153, 153, 51],
    name: 'Olive Drab',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '8',
  },
  {
    id: '49',
    hex: '#ff0000',
    rgb: [255, 0, 0],
    name: 'Red',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '9',
  },
  {
    id: '50',
    hex: '#bdb76b',
    rgb: [189, 183, 107],
    name: 'Dark Khaki',
    group: 'warm',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '10',
  },
  {
    id: '51',
    hex: '#dda0dd',
    rgb: [221, 160, 221],
    name: 'Plum',
    group: 'purple',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '11',
  },
  {
    id: '52',
    hex: '#4169e0',
    rgb: [65, 105, 224],
    name: 'Royal Blue',
    group: 'blue',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
    seriesId: '1',
    vehicleNumber: '12',
  },
  {
    id: '53',
    hex: '#6495ed',
    rgb: [100, 149, 237],
    name: 'Cornflower Blue (2)',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '14',
  },
  {
    id: '54',
    hex: '#afc3de',
    rgb: [175, 195, 222],
    name: 'Light Steel Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '15',
  },
  {
    id: '55',
    hex: '#7c68ed',
    rgb: [124, 104, 237],
    name: 'Medium Slate Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '16',
  },
  {
    id: '56',
    hex: '#3db372',
    rgb: [61, 179, 114],
    name: 'Medium Sea Green',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '17',
  },
  {
    id: '57',
    hex: '#808000',
    rgb: [128, 128, 0],
    name: 'Olive',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '18',
  },
  {
    id: '58',
    hex: '#a8a8a8',
    rgb: [168, 168, 168],
    name: 'Gray',
    group: 'neutral',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '19',
  },
  {
    id: '59',
    hex: '#d9a521',
    rgb: [217, 165, 33],
    name: 'Goldenrod',
    group: 'yellow',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '20',
  },
  {
    id: '60',
    hex: '#ffb6c1',
    rgb: [255, 182, 193],
    name: 'Light Pink',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '21',
  },
  {
    id: '61',
    hex: '#d2b48c',
    rgb: [210, 180, 140],
    name: 'Tan',
    group: 'neutral',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '22',
  },
  {
    id: '62',
    hex: '#ee82ee',
    rgb: [238, 130, 238],
    name: 'Violet',
    group: 'purple',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '23',
  },
  {
    id: '63',
    hex: '#ff8c00',
    rgb: [255, 140, 0],
    name: 'Dark Orange',
    group: 'orange',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '24',
  },
  {
    id: '64',
    hex: '#ff0000',
    rgb: [255, 0, 0],
    name: 'Red (2)',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '27',
  },
  {
    id: '65',
    hex: '#cc5c5c',
    rgb: [204, 92, 92],
    name: 'Indian Red (2)',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '29',
  },
  {
    id: '66',
    hex: '#db143c',
    rgb: [219, 20, 60],
    name: 'Crimson',
    group: 'red',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
    seriesId: '1',
    vehicleNumber: '31',
  },
  {
    id: '67',
    hex: '#008c8c',
    rgb: [0, 140, 140],
    name: 'Dark Cyan',
    group: 'aqua',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '34',
  },
  {
    id: '68',
    hex: '#31cc31',
    rgb: [49, 204, 49],
    name: 'Green (3)',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '38',
  },
  {
    id: '69',
    hex: '#cd853f',
    rgb: [205, 133, 63],
    name: 'Peru',
    group: 'warm',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '41',
  },
  {
    id: '70',
    hex: '#98cc31',
    rgb: [152, 204, 49],
    name: 'Green (4)',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '42',
  },
  {
    id: '71',
    hex: '#00ced1',
    rgb: [0, 206, 209],
    name: 'Dark Turquoise',
    group: 'aqua',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '43',
  },
  {
    id: '72',
    hex: '#008000',
    rgb: [0, 128, 0],
    name: 'Green',
    group: 'green',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
    seriesId: '1',
    vehicleNumber: '45',
  },
  {
    id: '73',
    hex: '#b0c4de',
    rgb: [176, 196, 222],
    name: 'Light Steel Blue (2)',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '47',
  },
  {
    id: '74',
    hex: '#31cc31',
    rgb: [49, 204, 49],
    name: 'Green (5)',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '48',
  },
  {
    id: '75',
    hex: '#31cc31',
    rgb: [49, 204, 49],
    name: 'Green (6)',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '50',
  },
  {
    id: '76',
    hex: '#98cc31',
    rgb: [152, 204, 49],
    name: 'Green (7)',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '51',
  },
  {
    id: '77',
    hex: '#807f00',
    rgb: [128, 127, 0],
    name: 'Olive (2)',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '54',
  },
  {
    id: '78',
    hex: '#cc863f',
    rgb: [204, 134, 63],
    name: 'Peru (2)',
    group: 'warm',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '55',
  },
  {
    id: '79',
    hex: '#dda0dd',
    rgb: [221, 160, 221],
    name: 'Plum (2)',
    group: 'purple',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '62',
  },
  {
    id: '80',
    hex: '#cc5c5c',
    rgb: [204, 92, 92],
    name: 'Indian Red (3)',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '66',
  },
  {
    id: '81',
    hex: '#87cefa',
    rgb: [135, 206, 250],
    name: 'Light Sky Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '77',
  },
  {
    id: '82',
    hex: '#9470db',
    rgb: [148, 112, 219],
    name: 'Medium Purple',
    group: 'purple',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '78',
  },
  {
    id: '83',
    hex: '#1e90ff',
    rgb: [30, 144, 255],
    name: 'Dodger Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '1',
    vehicleNumber: '99',
  },

  // Xfinity Series
  {
    id: '84',
    hex: '#cc6600',
    rgb: [204, 102, 0],
    name: 'Burnt Orange',
    group: 'custom',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '66',
  },
  {
    id: '85',
    hex: '#999933',
    rgb: [153, 153, 51],
    name: 'Olive Drab',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '86',
  },
  {
    id: '86',
    hex: '#ff00ff',
    rgb: [255, 0, 255],
    name: 'Magenta',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '20',
  },
  {
    id: '87',
    hex: '#6699cc',
    rgb: [102, 153, 204],
    name: 'Light Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '21',
  },
  {
    id: '88',
    hex: '#9370db',
    rgb: [147, 112, 219],
    name: 'Medium Purple',
    group: 'purple',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '22',
  },
  {
    id: '89',
    hex: '#dc143c',
    rgb: [220, 20, 60],
    name: 'Crimson',
    group: 'red',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
    seriesId: '2',
    vehicleNumber: '23',
  },
  {
    id: '90',
    hex: '#4169e1',
    rgb: [65, 105, 225],
    name: 'Royal Blue',
    group: 'blue',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
    seriesId: '2',
    vehicleNumber: '42',
  },
  {
    id: '91',
    hex: '#dda0dd',
    rgb: [221, 160, 221],
    name: 'Plum',
    group: 'purple',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '1',
  },
  {
    id: '92',
    hex: '#f08080',
    rgb: [240, 128, 128],
    name: 'Light Coral',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '00',
  },
  {
    id: '93',
    hex: '#ffa07a',
    rgb: [255, 160, 122],
    name: 'Light Salmon',
    group: 'orange',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '2',
  },
  {
    id: '94',
    hex: '#66cdaa',
    rgb: [102, 205, 170],
    name: 'Medium Aquamarine',
    group: 'aqua',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '7',
  },
  {
    id: '95',
    hex: '#1e90ff',
    rgb: [30, 144, 255],
    name: 'Dodger Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '9',
  },
  {
    id: '96',
    hex: '#6b8e23',
    rgb: [107, 142, 35],
    name: 'Olive Drab',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '8',
  },
  {
    id: '97',
    hex: '#a9a9a9',
    rgb: [169, 169, 169],
    name: 'Dark Gray',
    group: 'neutral',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '13',
  },
  {
    id: '98',
    hex: '#cd5c5c',
    rgb: [205, 92, 92],
    name: 'Indian Red',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '99',
  },
  {
    id: '99',
    hex: '#708090',
    rgb: [112, 128, 144],
    name: 'Slate Gray',
    group: 'neutral',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '98',
  },
  {
    id: '100',
    hex: '#d2b48c',
    rgb: [210, 180, 140],
    name: 'Tan',
    group: 'neutral',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '12',
  },
  {
    id: '101',
    hex: '#32cd32',
    rgb: [50, 205, 50],
    name: 'Lime Green',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '90',
  },
  {
    id: '102',
    hex: '#ff0000',
    rgb: [255, 0, 0],
    name: 'Red',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '93',
  },
  {
    id: '103',
    hex: '#ffa500',
    rgb: [255, 165, 0],
    name: 'Orange',
    group: 'orange',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '78',
  },
  {
    id: '104',
    hex: '#cc6666',
    rgb: [204, 102, 102],
    name: 'Light Coral',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '11',
  },
  {
    id: '105',
    hex: '#669999',
    rgb: [102, 153, 153],
    name: 'Cadet Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '10',
  },
  {
    id: '106',
    hex: '#00ced1',
    rgb: [0, 206, 209],
    name: 'Dark Turquoise',
    group: 'aqua',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '39',
  },
  {
    id: '107',
    hex: '#ff33cc',
    rgb: [255, 51, 204],
    name: 'Pink',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '38',
  },
  {
    id: '108',
    hex: '#ff6347',
    rgb: [255, 99, 71],
    name: 'Tomato',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '15',
  },
  {
    id: '109',
    hex: '#ff0099',
    rgb: [255, 0, 153],
    name: 'Hot Pink',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '17',
  },
  {
    id: '110',
    hex: '#008b8b',
    rgb: [0, 139, 139],
    name: 'Dark Cyan',
    group: 'aqua',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '19',
  },
  {
    id: '111',
    hex: '#808000',
    rgb: [128, 128, 0],
    name: 'Olive',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '18',
  },
  {
    id: '112',
    hex: '#00bfff',
    rgb: [0, 191, 255],
    name: 'Deep Sky Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '51',
  },
  {
    id: '113',
    hex: '#cd853f',
    rgb: [205, 133, 63],
    name: 'Peru',
    group: 'warm',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '36',
  },
  {
    id: '114',
    hex: '#778899',
    rgb: [119, 136, 153],
    name: 'Light Slate Gray',
    group: 'neutral',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '35',
  },
  {
    id: '115',
    hex: '#ff3366',
    rgb: [255, 51, 102],
    name: 'Coral',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '52',
  },
  {
    id: '116',
    hex: '#daa520',
    rgb: [218, 165, 32],
    name: 'Goldenrod',
    group: 'yellow',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '2',
    vehicleNumber: '74',
  },

  // Truck Series
  {
    id: '117',
    hex: '#f08080',
    rgb: [240, 128, 128],
    name: 'Light Coral',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '0',
  },
  {
    id: '118',
    hex: '#dda0dd',
    rgb: [221, 160, 221],
    name: 'Plum',
    group: 'purple',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '1',
  },
  {
    id: '119',
    hex: '#ffa07a',
    rgb: [255, 160, 122],
    name: 'Light Salmon',
    group: 'orange',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '2',
  },
  {
    id: '120',
    hex: '#630000',
    rgb: [99, 0, 0],
    name: 'Dark Red',
    group: 'red',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
    seriesId: '3',
    vehicleNumber: '4',
  },
  {
    id: '121',
    hex: '#004aac',
    rgb: [0, 74, 172],
    name: 'Blue',
    group: 'blue',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
    seriesId: '3',
    vehicleNumber: '5',
  },
  {
    id: '122',
    hex: '#66cdaa',
    rgb: [102, 205, 170],
    name: 'Medium Aquamarine',
    group: 'aqua',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '7',
  },
  {
    id: '123',
    hex: '#6b8e23',
    rgb: [107, 142, 35],
    name: 'Olive Drab',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '8',
  },
  {
    id: '124',
    hex: '#1e90ff',
    rgb: [30, 144, 255],
    name: 'Dodger Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '9',
  },
  {
    id: '125',
    hex: '#669999',
    rgb: [102, 153, 153],
    name: 'Cadet Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '10',
  },
  {
    id: '126',
    hex: '#cc6666',
    rgb: [204, 102, 102],
    name: 'Light Coral',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '11',
  },
  {
    id: '127',
    hex: '#d2b48c',
    rgb: [210, 180, 140],
    name: 'Tan',
    group: 'neutral',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '12',
  },
  {
    id: '128',
    hex: '#f4ff3c',
    rgb: [244, 255, 60],
    name: 'Lemon Yellow',
    group: 'yellow',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '13',
  },
  {
    id: '129',
    hex: '#ff6347',
    rgb: [255, 99, 71],
    name: 'Tomato',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '15',
  },
  {
    id: '130',
    hex: '#ffa055',
    rgb: [255, 160, 85],
    name: 'Light Salmon',
    group: 'orange',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '16',
  },
  {
    id: '131',
    hex: '#ff0099',
    rgb: [255, 0, 153],
    name: 'Hot Pink',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '17',
  },
  {
    id: '132',
    hex: '#808000',
    rgb: [128, 128, 0],
    name: 'Olive',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '18',
  },
  {
    id: '133',
    hex: '#008b8b',
    rgb: [0, 139, 139],
    name: 'Dark Cyan',
    group: 'aqua',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '19',
  },
  {
    id: '134',
    hex: '#ff00ff',
    rgb: [255, 0, 255],
    name: 'Magenta',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '20',
  },
  {
    id: '135',
    hex: '#6699cc',
    rgb: [102, 153, 204],
    name: 'Light Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '21',
  },
  {
    id: '136',
    hex: '#9370db',
    rgb: [147, 112, 219],
    name: 'Medium Purple',
    group: 'purple',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '22',
  },
  {
    id: '137',
    hex: '#dc143c',
    rgb: [220, 20, 60],
    name: 'Crimson',
    group: 'red',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
    seriesId: '3',
    vehicleNumber: '23',
  },
  {
    id: '138',
    hex: '#69b0ff',
    rgb: [105, 176, 255],
    name: 'Cornflower Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '24',
  },
  {
    id: '139',
    hex: '#2b7cff',
    rgb: [43, 124, 255],
    name: 'Royal Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '25',
  },
  {
    id: '140',
    hex: '#ff6666',
    rgb: [255, 102, 102],
    name: 'Light Coral',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '32',
  },
  {
    id: '141',
    hex: '#c10000',
    rgb: [193, 0, 0],
    name: 'Red',
    group: 'red',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
    seriesId: '3',
    vehicleNumber: '33',
  },
  {
    id: '142',
    hex: '#778899',
    rgb: [119, 136, 153],
    name: 'Light Slate Gray',
    group: 'neutral',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '35',
  },
  {
    id: '143',
    hex: '#cd853f',
    rgb: [205, 133, 63],
    name: 'Peru',
    group: 'warm',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '36',
  },
  {
    id: '144',
    hex: '#ff33cc',
    rgb: [255, 51, 204],
    name: 'Pink',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '38',
  },
  {
    id: '145',
    hex: '#00ced1',
    rgb: [0, 206, 209],
    name: 'Dark Turquoise',
    group: 'aqua',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '39',
  },
  {
    id: '146',
    hex: '#39d3ff',
    rgb: [57, 211, 255],
    name: 'Cyan',
    group: 'aqua',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '41',
  },
  {
    id: '147',
    hex: '#4169e1',
    rgb: [65, 105, 224],
    name: 'Royal Blue',
    group: 'blue',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
    seriesId: '3',
    vehicleNumber: '42',
  },
  {
    id: '148',
    hex: '#55e1ff',
    rgb: [85, 225, 255],
    name: 'Light Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '43',
  },
  {
    id: '149',
    hex: '#c4ff48',
    rgb: [196, 255, 72],
    name: 'Pastel Green',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '45',
  },
  {
    id: '150',
    hex: '#ffd32a',
    rgb: [255, 211, 42],
    name: 'Dandelion Yellow',
    group: 'yellow',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '46',
  },
  {
    id: '151',
    hex: '#7e7e7e',
    rgb: [126, 126, 126],
    name: 'Gray',
    group: 'neutral',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '47',
  },
  {
    id: '152',
    hex: '#00bfff',
    rgb: [0, 191, 255],
    name: 'Deep Sky Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '51',
  },
  {
    id: '153',
    hex: '#ff3366',
    rgb: [255, 51, 102],
    name: 'Coral',
    group: 'pink',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '52',
  },
  {
    id: '154',
    hex: '#8937ff',
    rgb: [137, 55, 255],
    name: 'Light Purple',
    group: 'purple',
    contrastTextHex: '#FFFFFF',
    contrastTextRGB: [255, 255, 255],
    seriesId: '3',
    vehicleNumber: '56',
  },
  {
    id: '155',
    hex: '#cc6600',
    rgb: [204, 102, 0],
    name: 'Brown',
    group: 'neutral',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '66',
  },
  {
    id: '156',
    hex: '#daa520',
    rgb: [218, 165, 32],
    name: 'Goldenrod',
    group: 'yellow',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '74',
  },
  {
    id: '157',
    hex: '#ffa500',
    rgb: [255, 165, 0],
    name: 'Orange',
    group: 'orange',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '78',
  },
  {
    id: '158',
    hex: '#999933',
    rgb: [153, 153, 51],
    name: 'Olive Drab',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '86',
  },
  {
    id: '159',
    hex: '#e5ff00',
    rgb: [229, 255, 0],
    name: 'Lemon Yellow',
    group: 'yellow',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '88',
  },
  {
    id: '160',
    hex: '#32cd32',
    rgb: [50, 205, 50],
    name: 'Lime Green',
    group: 'green',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '90',
  },
  {
    id: '161',
    hex: '#ff0000',
    rgb: [255, 0, 0],
    name: 'Red',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '93',
  },
  {
    id: '162',
    hex: '#708090',
    rgb: [112, 128, 144],
    name: 'Slate Gray',
    group: 'neutral',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '98',
  },
  {
    id: '163',
    hex: '#cd5c5c',
    rgb: [205, 92, 92],
    name: 'Indian Red',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '99',
  },
  {
    id: '164',
    hex: '#6685ff',
    rgb: [102, 133, 255],
    name: 'Periwinkle Blue',
    group: 'blue',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '02',
  },
  {
    id: '165',
    hex: '#ff5c5c',
    rgb: [255, 92, 92],
    name: 'Light Red',
    group: 'red',
    contrastTextHex: '#000000',
    contrastTextRGB: [0, 0, 0],
    seriesId: '3',
    vehicleNumber: '04',
  },
];
